// import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
// import { apiUrl, baseUrl } from "../../../utils/apis";
// import { FaqResponse, SpecializationsApiItem, SpecializationsPayload } from "./types";



// export const specializationsApiFetching = createApi({
//     reducerPath: "specializationsApi",
//     baseQuery: fetchBaseQuery({
//         baseUrl,

//         prepareHeaders: (headers) => {
//             const token = sessionStorage.getItem("token");

//             headers.set("Content-Type", "application/json");

//             if (token) {
//                 headers.set("Authorization", `Bearer ${token}`);
//             }

//             return headers;

//         },
//     }),
//     tagTypes: ["specialization"],

//     endpoints: (builder) => ({
//         getSpecializationList: builder.query<FaqResponse, void>({
//             query: () => ({
//                 url: apiUrl.specializations,
//                 method: "GET",
//                 providesTags: ["specialization"],

//             }),

//         }),

//         postSpecialization: builder.mutation({
//             query: (bodyData: SpecializationsPayload) => ({
//                 url: apiUrl.specializations,
//                 method: "POST",
//                 body: bodyData,
//             }),
//             invalidatesTags: ["specialization"],
//         }),
//                 postSubSpecialization: builder.mutation({
//             query: (bodyData: SpecializationsPayload) => ({
//                 url: apiUrl.subSpecializations,
//                 method: "POST",
//                 body: bodyData,
//             }),
//             invalidatesTags: ["specialization"],
//         }),
//         updateSpecialization: builder.mutation<SpecializationsApiItem, { id: number | string; data: Partial<SpecializationsApiItem>, }>({
//             query: ({ id, data }) => ({
//                 url: `${apiUrl.specializations}${id}/`,
//                 method: "PUT",
//                 body: data,
//             }),
//             invalidatesTags: ["specialization"],
//         }),
//         deleteSpecialization: builder.mutation<{ success: boolean; message: string }, number>({
//             query: (id) => ({
//                 url: `${apiUrl.specializations}${id}/`,
//                 method: "DELETE",
//             }),
//             invalidatesTags: ["specialization"], 
//         }),
//     }),
// });

// export const { useGetSpecializationListQuery,useDeleteSpecializationMutation,usePostSpecializationMutation,useUpdateSpecializationMutation,usePostSubSpecializationMutation} = specializationsApiFetching;






import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { apiUrl, baseUrl } from "../../../utils/apis";
import { FaqResponse, SpecializationsApiItem, SpecializationsPayload, SubSpecializationsPayload, SubSpecializationsResponse } from "./types";



export const specializationsApiFetching = createApi({
    reducerPath: "specializationsApi",
    baseQuery: fetchBaseQuery({
        baseUrl,

        prepareHeaders: (headers) => {
            const token = sessionStorage.getItem("token");

            headers.set("Content-Type", "application/json");

            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }

            return headers;

        },
    }),
    tagTypes: ["specialization"],

    endpoints: (builder) => ({
        getSpecializationList: builder.query<FaqResponse, void>({
            query: () => ({
                url: apiUrl.specializations,
                method: "GET",
                providesTags: ["specialization"],

            }),

        }),

        // postSpecialization: builder.mutation({
        //     query: (bodyData: SpecializationsPayload) => ({
        //         url: apiUrl.specializations,
        //         method: "POST",
        //         body: bodyData,
        //     }),
        //     invalidatesTags: ["specialization"],
        // }),
        postSpecialization: builder.mutation<
            SpecializationsApiItem,
            FormData
        >({
            query: (formData) => ({
                url: apiUrl.specializations,
                method: "POST",
                body: formData,
            }),
            invalidatesTags: ["specialization"],
        }),
        // updateSpecialization: builder.mutation<SpecializationsApiItem, { id: number | string; data: Partial<SpecializationsApiItem>, }>({
        //     query: ({ id, data }) => ({
        //         url: `${apiUrl.specializations}${id}/`,
        //         method: "PUT",
        //         body: data,
        //     }),
        //     invalidatesTags: ["specialization"],
        // }),

        updateSpecialization: builder.mutation<
            SpecializationsApiItem,
            {
                id: number | string;
                data: FormData;
            }
        >({
            query: ({ id, data }) => ({
                url: `${apiUrl.specializations}${id}/`,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ["specialization"],
        }),
        postSubSpecialization: builder.mutation({
            query: (bodyData: SubSpecializationsPayload) => ({
                url: apiUrl.subSpecializations,
                method: "POST",
                body: bodyData,
            }),
            invalidatesTags: ["specialization"],
        }),
        updateSubSpecialization: builder.mutation<
            SubSpecializationsPayload,
            { id: number | string; data: SubSpecializationsPayload }
        >({
            query: ({ id, data }) => ({
                url: `${apiUrl.subSpecializations}${id}/`,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ["specialization"],
        }),
        getSubSpecializationList: builder.query<SubSpecializationsResponse, number>({
            query: (specializationId) => ({
                url: `${apiUrl.subSpecializationsList}${specializationId}`,
                method: "GET",
            }),
            providesTags: ["specialization"],
        }),
        getSpecializationDetails: builder.query<SpecializationsApiItem, number>({
            query: (id) => ({
                url: `${apiUrl.specializationsDetails}${id}/`,
                method: "GET",
            }),
            providesTags: ["specialization"],
        }),
        deleteSpecialization: builder.mutation<{ success: boolean; message: string }, number>({
            query: (id) => ({
                url: `${apiUrl.specializations}${id}/`,
                method: "DELETE",
            }),
            invalidatesTags: ["specialization"],
        }),
                deleteSubSpecialization: builder.mutation<{ success: boolean; message: string }, number>({
            query: (id) => ({
                url: `${apiUrl.subSpecializations}${id}/`,
                method: "DELETE",
            }),
            invalidatesTags: ["specialization"], 
        }),
    }),
});

export const { useGetSpecializationListQuery, useDeleteSpecializationMutation, usePostSpecializationMutation, useUpdateSpecializationMutation, usePostSubSpecializationMutation, useGetSpecializationDetailsQuery, useUpdateSubSpecializationMutation, useDeleteSubSpecializationMutation, useGetSubSpecializationListQuery } = specializationsApiFetching;





